__turbopack_context__.v({
  "iconWrapper": "styles-module-scss-module__ZW394G__iconWrapper",
  "socialItems": "styles-module-scss-module__ZW394G__socialItems",
});
